import { registerPlugin } from '@capacitor/core'

export interface OfflineQueueNativePlugin {
  register: () => Promise<void>
  drain: () => Promise<void>
}

export const OfflineQueueNative = registerPlugin<OfflineQueueNativePlugin>('OfflineQueueNative')
